import { YellowHorizontal } from '@/vm/Shared/YellowHorizontal.styles';
import {
  Header,
  HeaderWrapper,
  HeaderSubTextBold
} from '../Shared/Shared.styles';

type OwnProps = {
  city: string;
  state: string;
};

export default function CityHeader({ city, state }: OwnProps) {
  return (
    <>
      <HeaderWrapper>
        <YellowHorizontal />
        <Header>
          {city}, {state}
        </Header>
        <HeaderSubTextBold>Car Vending Machine Location</HeaderSubTextBold>
      </HeaderWrapper>
    </>
  );
}
